// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__zPeIe","title":"Info_title__2nJ3a","links":"Info_links__38Zrn","link":"Info_link__3Muy1","logo":"Info_logo__1G4PI"};